<p-table [value]="data" dataKey="id" editMode="row">
  <ng-template pTemplate="header">
    <tr>
      <th>ID</th>
      <th>Titel</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="item">
      <td>
        {{ item.id }}
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="text" [(ngModel)]="item.title" required>
          </ng-template>
          <ng-template pTemplate="output">
            {{ item.title }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <div class="flex align-items-center justify-content-center gap-2">
          @if (!editing) {
            <p-button pInitEditableRow icon="pi pi-pencil" [rounded]="true" [outlined]="true"
                      (click)="onRowEditInit(item)" class="mr-2"></p-button>
          }
          @if (!editing) {
            <p-button icon="pi pi-trash" [rounded]="true" [outlined]="true" severity="danger"
                      (click)="deleteItem($event, item)"></p-button>
          }
          @if (editing) {
            <p-button pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(item)" [rounded]="true"
                      [outlined]="true" severity="success" class="mr-2"></p-button>
          }
          @if (editing) {
            <p-button pCancelEditableRow icon="pi pi-times"
                      (click)="onRowEditCancel(item, ri)" [rounded]="true" [outlined]="true"
                      severity="danger"></p-button>
          }
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="d-flex mt-5">
  <div class="flex-grow-1 mr-2">
    <p-floatlabel>
      <input #new id="float-input" class="w-100" type="text" pInputText>
      <label for="float-input">Titel</label>
    </p-floatlabel>
  </div>
  <p-button icon="pi pi-plus" label="HINZUFÜGEN" (click)="create.emit(new.value); new.value=''"></p-button>
</div>

<p-confirmpopup></p-confirmpopup>
